import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { ActivityActionTypes, ActivityActions } from "../../../actionTypes/sales/activityActionTypes";
import {
  createActivityApi,
  editActivityDataByIdApi,
  editMyActivityDataByIdApi,
  getActivityDataByIdApi,
  getActivityListApi,
  getMyActivityDataByIdApi,
  getMyActivityListApi,
} from "../../requests/sales/activityRequests";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  getActivityList,
  setActivityDataById,
  setActivityList,
  setActivityListPageCount,
  setMyActivityData,
  setMyActivityList,
  setMyActivityListPageCount,
} from "../../../actions/sales/activityActions";


function* createActivityHandler(action: ActivityActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createActivityApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getActivityListHandler(action: ActivityActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getActivityListApi, action.payload);

    if (data.status) {
      const fallbackData = [
        {
          id: 0,
          title: "-",
          target_type: "-",
          target_code: "-",
          assigned_to: 0,
          event_type: "-",
          event_date: "-",
          location: "-",
          agenda: "-",
          activity_status: "-",
          cancel_reason: "-",
          created_by: 0,
          assigned_user: {
            id: 0,
            name: "-",
          },
          lead: {},
          customer: {},
        }
      ]
      yield put(setActivityList(data?.data?.rows || fallbackData));
      yield put(setActivityListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getActivityDataByIdHandler(action: ActivityActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getActivityDataByIdApi, action.payload);
    if (data.status) {
      yield put(setActivityDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editActivityDataByIdHandler(action: ActivityActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editActivityDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getActivityList({ page: 0, pageLimit: 10, type: action.payload.type, team: action.payload.team }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getMyActivityListHandler(action: ActivityActionTypes) {
  if (action.payload.search) {
    yield delay(500);
  }
  try {
    yield startLoader("transparent");
    const { data } = yield call(getMyActivityListApi, action.payload);
    if (data.status) {
      const fallbackData = [
        {
          id: 0,
          title: "-",
          target_name: "-",
          target_type: "-",
          activity_logs: "-",
          target_code: "-",
          assigned_to: 0,
          event_type: "-",
          location: "-",
          agenda: "-",
          activity_status: "-",
          cancel_reason: "-",
          created_by: 0,
          customer_id: 0,
          lead_id: "",
        },
      ];
      yield put(setMyActivityList(data?.data?.rows || fallbackData));
      yield put(setMyActivityListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getMyActivityDataByIdHandler(action: ActivityActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getMyActivityDataByIdApi, action.payload);
    if (data.status) {
      yield put(setMyActivityData(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editMyActivityDataByIdHandler(action: ActivityActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editMyActivityDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      // yield put(getActivityList({ page: 0, pageLimit: 10, type: action.payload.type, team: action.payload.team }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// activity sagas
export default function* activitySaga() {
  yield takeLatest(ActivityActions.CREATE_ACTIVITY, createActivityHandler);
  yield takeLatest(ActivityActions.GET_ACTIVITY_LIST, getActivityListHandler);
  yield takeLatest(ActivityActions.GET_ACTIVITY_DATA_BY_ID, getActivityDataByIdHandler);
  yield takeLatest(ActivityActions.EDIT_ACTIVITY_DATA_BY_ID, editActivityDataByIdHandler);
  yield takeLatest(ActivityActions.GET_MY_ACTIVITY_LIST, getMyActivityListHandler);
  yield takeLatest(ActivityActions.GET_MY_ACTIVITY_BY_ID, getMyActivityDataByIdHandler);
  yield takeLatest(ActivityActions.EDIT_MY_ACTIVITY_BY_ID, editMyActivityDataByIdHandler);
}
